// @ts-expect-error -- sortablejs ships without type definitions
import Sortable from 'sortablejs';

interface SortableListOptions {
  // The grip class that starts a drag, so dragging the box itself does nothing.
  handle: string;
  onMove: (from: number, to: number) => void;
}

// Lets a Svelte list be reordered by dragging its grips. Sortable's own move is undone
// so the Svelte list does the moving, which keeps the page and the list in the same order.
export function sortableList(node: HTMLElement, { handle, onMove }: SortableListOptions) {
  const sortable = Sortable.create(node, {
    handle,
    // Keeps items in their own list, since the curation and section lists accept drops from any list.
    group: { pull: false, put: false },
    animation: 200,
    onEnd: ({ item, from, oldIndex, newIndex }: { item: HTMLElement; from: HTMLElement; oldIndex: number; newIndex: number }) => {
      if (oldIndex === newIndex) return;
      from.insertBefore(item, from.children[oldIndex < newIndex ? oldIndex : oldIndex + 1]);
      onMove(oldIndex, newIndex);
    },
  });

  return { destroy: () => sortable.destroy() };
}
